import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import MovieSection from './components/MovieSection';
import RankingSection from './components/RankingSection';
import { heroMovies, latestMovies, hotRanking, tvShows, animeShows, varietyShows } from '@/mocks/movies';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '被窝影院',
    url: 'https://www.beiwoyingyuan.com',
    description: '被窝影院官网提供高清电影电视剧免费在线观看，最新热门影片每日更新，支持APP下载，不缓冲不卡顿。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.beiwoyingyuan.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '被窝影院',
    url: 'https://www.beiwoyingyuan.com',
    description: '被窝影院 - 高清电影电视剧免费在线观看平台',
    sameAs: [
      'https://www.beiwoyingyuan.com',
    ],
  };

  return (
    <>
      <SEO
        title="被窝影院官网 | 被窝影院APP下载与被窝影院在线观看，最新地址首页高清电影电视剧免费大全全集在线看不缓冲"
        description="被窝影院官网提供官方入口，被窝影院APP下载与被窝影院在线观看，最新地址首页直达，高清电影电视剧免费大全全集在线看不缓冲，安全便捷。"
        keywords="被窝影院,被窝影院官网,被窝影院APP,被窝影院在线观看,被窝影院最新地址,被窝影院首页,高清电影,电视剧免费大全,全集在线看,不缓冲"
        canonicalUrl="https://www.beiwoyingyuan.com"
        ogImage={heroMovies[0].backdrop}
        schema={{ ...homeSchema, ...orgSchema }}
      />

      <Navbar />

      <main>
        <HeroSection movies={heroMovies} />

        <CategoryNav />

        <MovieSection
          title="最新推荐"
          subtitle="每日更新热门影片，精彩不容错过"
          movies={latestMovies}
          viewAllLink="/category/movie"
        />

        <section className="w-full px-4 md:px-6">
          <div className="max-w-[1400px] mx-auto">
            <div className="h-px bg-gradient-to-r from-transparent via-background-700/50 to-transparent"></div>
          </div>
        </section>

        <RankingSection
          title="热门排行榜"
          movies={hotRanking.slice(0, 10)}
          viewAllLink="/category/movie"
        />

        <section className="w-full px-4 md:px-6">
          <div className="max-w-[1400px] mx-auto">
            <div className="h-px bg-gradient-to-r from-transparent via-background-700/50 to-transparent"></div>
          </div>
        </section>

        <MovieSection
          title="电视剧专区"
          subtitle="热门剧集，一网打尽"
          movies={tvShows}
          viewAllLink="/category/tv"
        />

        <MovieSection
          title="动漫精选"
          subtitle="国漫日漫，精彩纷呈"
          movies={animeShows}
          viewAllLink="/category/anime"
        />

        <MovieSection
          title="综艺热播"
          subtitle="爆笑综艺，轻松一刻"
          movies={varietyShows}
          viewAllLink="/category/variety"
        />

        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-[1400px] mx-auto">
            <div className="rounded-2xl bg-gradient-to-r from-primary-500/10 via-accent-500/10 to-primary-500/10 border border-background-700/30 p-8 md:p-12 text-center">
              <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-100 mb-3">
                随时随地，畅享高清观影
              </h3>
              <p className="text-sm md:text-base text-foreground-400 mb-6 max-w-lg mx-auto">
                下载被窝影院APP，海量高清电影电视剧免费看，支持离线缓存，不缓冲不卡顿，随时随地畅享观影乐趣。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <a
                  href="#"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-950 text-sm font-label font-semibold hover:bg-primary-400 transition-all cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-android-line text-lg"></i>
                  Android 下载
                </a>
                <a
                  href="#"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-foreground-300/30 text-foreground-100 text-sm font-label hover:bg-foreground-50/5 transition-all cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-apple-line text-lg"></i>
                  iOS 下载
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-8 md:py-10">
          <div className="max-w-[1400px] mx-auto">
            <h3 className="text-lg font-heading font-bold text-foreground-100 mb-4">常见问题</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {[
                {
                  q: '被窝影院可以在线观看高清电影吗？',
                  a: '是的，被窝影院提供高清电影电视剧在线观看服务，支持多种清晰度选择，不缓冲不卡顿，为您带来流畅的观影体验。',
                },
                {
                  q: '被窝影院APP如何下载？',
                  a: '您可以在本页面找到Android和iOS下载入口，点击对应按钮即可下载被窝影院APP。APP支持离线缓存功能，随时随地观看。',
                },
                {
                  q: '被窝影院最新地址在哪里？',
                  a: '被窝影院最新地址请收藏本站首页，我们会持续更新确保您能正常访问。建议同时下载APP，更加稳定便捷。',
                },
                {
                  q: '被窝影院是否免费？',
                  a: '被窝影院提供完全免费的影视内容在线观看服务，无需注册会员即可畅享海量高清电影电视剧资源。',
                },
              ].map((faq, i) => (
                <div key={i} className="p-4 rounded-xl bg-background-900/50 border border-background-800/50">
                  <h4 className="text-sm font-label font-semibold text-foreground-200 mb-2">
                    {faq.q}
                  </h4>
                  <p className="text-xs text-foreground-500 leading-relaxed">{faq.a}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}